export default __webpack_public_path__ + "static/B0185-2e01c069f6bb3c564435ca49f07c2c48.png";